import React from 'react';
import { motion } from 'framer-motion';

const services = [
  {
    category: 'Web Design & Development',
    items: [
      'Custom website design & build',
      'Responsive, mobile-first development',
      'CMS setup & content migration',
      'Hosting, domain & ongoing maintenance',
    ],
  },
  {
    category: 'AI Tools & Automation',
    items: [
      'Custom AI-powered tools for your workflow',
      'Process automation & efficiency audits',
      'Data pipeline design & implementation',
      'AI integration into existing products',
    ],
  },
];

function Consulting() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <section style={{
        padding: 'calc(70px + 3rem) clamp(2rem, 5vw, 6rem) 4rem',
        maxWidth: '900px',
        margin: '0 auto',
      }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        >
          <h1 style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: 'clamp(2rem, 5vw, 3rem)',
            fontWeight: 400,
            color: 'var(--color-text)',
            marginBottom: '0.5rem',
          }}>
            Consulting
          </h1>
          <p style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '1.05rem',
            color: 'var(--color-text-muted)',
            marginBottom: '3rem',
            maxWidth: '550px',
            lineHeight: 1.6,
          }}>
            I design and build websites, AI-powered tools, and workflow automations
            for small businesses and teams who want to move faster.
          </p>
        </motion.div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '2.5rem' }}>
          {services.map((service, i) => (
            <motion.div
              key={service.category}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 + i * 0.15, ease: [0.16, 1, 0.3, 1] }}
            >
              <h2 style={{
                fontFamily: "'Playfair Display', Georgia, serif",
                fontSize: '1.3rem',
                fontWeight: 400,
                color: 'var(--color-text)',
                marginBottom: '1rem',
                paddingBottom: '0.5rem',
                borderBottom: '1px solid rgba(45, 42, 38, 0.1)',
              }}>
                {service.category}
              </h2>
              <ul style={{
                listStyle: 'none',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.6rem',
              }}>
                {service.items.map((item) => (
                  <li
                    key={item}
                    style={{
                      fontFamily: "'Inter', sans-serif",
                      fontSize: '0.95rem',
                      color: 'var(--color-text-muted)',
                      paddingLeft: '1rem',
                      position: 'relative',
                    }}
                  >
                    <span style={{
                      position: 'absolute',
                      left: 0,
                      color: 'var(--color-primary)',
                      opacity: 0.6,
                    }}>
                      ·
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.7 }}
          style={{
            marginTop: '3rem',
            padding: '2rem',
            background: 'var(--color-dark-card)',
            borderRadius: '8px',
            border: '1px solid rgba(45, 42, 38, 0.06)',
          }}
        >
          <p style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '0.95rem',
            color: 'var(--color-text-muted)',
            lineHeight: 1.6,
            marginBottom: '1rem',
          }}>
            Every project starts with a conversation. Tell me what you need
            and I'll scope out a plan with timeline and pricing.
          </p>
          <a
            href="mailto:sami@samidenicola.com"
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '0.9rem',
              fontWeight: 500,
              color: 'var(--color-primary)',
              textDecoration: 'none',
            }}
          >
            sami@samidenicola.com →
          </a>
        </motion.div>
      </section>
    </motion.div>
  );
}

export default Consulting;
